export const track = (event, params = {}) => {
  window.gtag?.("event", event, params);
};
